import * as PIDS from './pids';
import request from '../../lib/request';

/**
 * 获取七牛上传图片 token
 * @see https://wiki.zenmen.com/pages/viewpage.action?pageId=109636773
 * @param {Object} data { bizId }
 */
// eslint-disable-next-line import/prefer-default-export
export function getQiniuUploadImageToken(data) {
  return request(PIDS.GET_QINIU_IMAGE_UPLOAD_TOKEN, data);
}

// 查询保险投保详情
export function getInsuranceInfo(data) {
  return request(PIDS.GET_INSURANCE_INFO, data);
}

// 查询保险投保详情
export function getInsuranceQueryInfo(data) {
  return request(PIDS.GET_INSURANCE_QUERY_INFO, data);
}

// 保险投保接口
export function commitInsurance(data) {
  return request(PIDS.COMMIT_INSURANCE, data);
}
// 提交索赔
export function commitClam(data) {
  return request(PIDS.COMMIT_CLAIM, data);
}
// 提交索赔列表
export function commitClamList(data) {
  return request(PIDS.COMMIT_CLAIM_LIST, data);
}




// WEBPACK FOOTER //
// ./src/services/common/index.js